<p-toast
  [position]="position"
  [key]="key"
  [styleClass]="
    (positionType === 'relative' ? 'relative-toast' : 'absolute-toast') +
    ' ' +
    (!closable ? 'hide-close-button' : '') +
    ' ' +
    customContentClass
  "
  [style]="customContentStyle"
  (onClose)="onToastClose($event)"
>
  <ng-template let-message pTemplate="message">
    <!-- Error Severity -->
    <div
      *ngIf="message.severity === 'error'"
      class="flex flex-row items-center justify-between w-full gap-3"
    >
      <div class="flex-1 flex flex-row items-center">
        <i class="pi pi-exclamation-circle"></i>
        <p class="text-xs px-1 inline-block text-[#690421]">
          {{ message.summary }}
        </p>
        <button
          *ngIf="message.detail"
          type="button"
          class="text-button text-xs mr-1"
          [pTooltip]="message.detail"
          tooltipPosition="bottom"
          [escape]="false"
          [autoHide]="false"
          tooltipStyleClass="toast-detail-tooltip text-xs"
        >
          جزئیات بیشتر
        </button>
      </div>
      <ng-icon
        *ngIf="copyEnabled"
        name="lucideCopy"
        class="cursor-pointer !text-black !hover:text-gray-800"
        (click)="
          copyToClipboard(
            message.summary + (message.detail ? ' ' + message.detail : '')
          )
        "
      >
      </ng-icon>
    </div>

    <!-- Success Severity -->
    <div *ngIf="message.severity === 'success'" class="success-toast">
      <div class="flex flex-row items-center gap-2 mb-2">
        <div
          class="flex items-center mr-2 justify-center p-2 bg-green-200 rounded-full"
        >
          <ng-icon
            name="lucideCircleCheck"
            size="20"
            class="text-primary-600"
          ></ng-icon>
        </div>
        <p class="text-sm text-black p-4">
          {{ message.detail ? message.detail : message.summary }}
        </p>
      </div>
      <p-progressbar
        [value]="progress"
        [showValue]="false"
        [style]="{
          height: '4px',
          '--transition-duration': transitionDuration + 'ms'
        }"
        styleClass="success-progress"
      >
      </p-progressbar>
    </div>

    @if (message.severity === 'info'){
    <div class="flex flex-row items-center justify-between w-full gap-3">
      <div class="flex-1 flex flex-row items-center px-2">
        <i class="pi pi-exclamation-circle"></i>
        <p class="text-xs px-1 inline-block">
          {{ message.summary }}
        </p>
      </div>
    </div>
    }
  </ng-template>
</p-toast>
